import React from 'react'

import classes from './Skeleton.module.scss'

type SkeletonProps = {
  count?: number
  width?: number | string
  height?: number | string
  circle?: boolean
  className?: string
  mainWidth?: number | string
}

type customStyle = {
  width?: number | string
  height?: number | string
  borderRadius?: string
}

export function Skeleton({
  count,
  width,
  height,
  circle,
  className: customClassName,
  mainWidth,
}: SkeletonProps): JSX.Element {
  const elements = []
  const _count = count || 1
  const _mainWidth = mainWidth || '100%'

  for (let i = 0; i < _count; i++) {
    const style: customStyle = {}

    if (width !== null) {
      style.width = width
    }

    if (height !== null) {
      style.height = height
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = '50%'
    }

    elements.push(
      <span
        key={i}
        className={`${classes.skeleton} ${customClassName}`}
        style={{
          ...style,
        }}
      >
        &zwnj;
      </span>
    )
  }

  return <span style={{ width: _mainWidth }}>{elements}</span>
}
